import React from "react";
import { Trans, withTranslation } from "react-i18next";

const ButtonRow = ({ handleShiftPage, buttonStatus }) => {
  return (
    <div className="button-row">
      {/**BUTTON Send */}
      <button
        className={`req-button ${buttonStatus == 0 ? "active-button" : ""}`}
        onClick={() => handleShiftPage(0)}
      >
        <h2 className="heading-secondary">
          <Trans i18nKey="Send request">Send Request</Trans>
        </h2>
      </button>
      {/**BUTTON REQUEST */}
      <button
        className={`req-button ${buttonStatus == 1 ? "active-button" : ""}`}
        onClick={() => handleShiftPage(1)}
      >
        <h2 className="heading-secondary"><Trans i18nKey="Received request">Received request</Trans></h2>
      </button>
    </div>
  );
};

export default ButtonRow;
